import { Languages } from "src/common/descriptions/types";
import { CreatePayableContractDescriptions } from "./types";

const DescriptionsEnUs: CreatePayableContractDescriptions = {
    TITLE: "Create Payable Contract",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Payable Contract Confirmation',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Payalbe Contract input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Payable Contract Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Payable Contract Updated",
    },
    MAIN_ACTION_TITLE: "Creating Service Contract",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    FORM: {
        IS_MONTHLY: {
            LABEL: "Is Monthly",
            PLACEHOLDER: "Select option",
        },
        START_DATE: {
            LABEL: "Start Date",
            PLACEHOLDER: "Select date",
        },
        PAY_DATE: {
            LABEL: "Pay Date",
            PLACEHOLDER: "Input pay date",
        },
        NEXT_SERVICE_DEBIT_DATE: {
            LABEL: "Next Service Debit Date",
            PLACEHOLDER: "Next service debit date",
        },
        AMOUNT: {
            LABEL: "Amount",
            PLACEHOLDER: "0.00",
        },
        SERVICE_CATEGORY: {
            LABEL: "Service Category",
            PLACEHOLDER: "Select category",
        },
        DESCRIPTION: {
            LABEL: "Description",
            PLACEHOLDER: "Input descrption",
        },
    },
    DESTROY: {
        INACTIVATE_KEY: "inactivate",
        TITLE: "Payable Contract Inactivation",
        DESCRIPTION: 'To confirm inactivation, please type "inactivate"',
        FORM: {
            CONFIRMATION: {
                LABEL: "",
                PLACEHOLDER: "inactivate",
            }
        }
    },
    INACTIVATE_CONTRACT: "Inactivate contract",
    ACTIVATE_CONTRACT: "Activate contract",
}

const DescriptionsEsUs: CreatePayableContractDescriptions = {
    TITLE: "Crear Contrato de Pagos",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Contato de Pagos',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Contrato de Pagos?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Contrato de Pagos creado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Contrato de Pagos Actualizado",
    },
    MAIN_ACTION_TITLE: "Creando Categoría",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    FORM: {
        IS_MONTHLY: {
            LABEL: "Es Mensual",
            PLACEHOLDER: "Seleccione una opción",
        },
        START_DATE: {
            LABEL: "Fecha Inicio",
            PLACEHOLDER: "Seleccione fecha",
        },
        PAY_DATE: {
            LABEL: "Día de pago",
            PLACEHOLDER: "Ingrese día de pago",
        },
        NEXT_SERVICE_DEBIT_DATE: {
            LABEL: "Siguiente fecha cobro",
            PLACEHOLDER: "Siguiente fecha de cobro",
        },
        AMOUNT: {
            LABEL: "Monto",
            PLACEHOLDER: "0.00",
        },
        SERVICE_CATEGORY: {
            LABEL: "Categoría de Servicio",
            PLACEHOLDER: "Seleccione categoría",
        },
        DESCRIPTION: {
            LABEL: "Descripción",
            PLACEHOLDER: "Ingresa descrpción",
        },
    },
    DESTROY: {
        INACTIVATE_KEY: "inactivar",
        TITLE: "Inactivación Contrato Proveedor",
        DESCRIPTION: 'Para confirmar la inactivación, por favor escrite "inactivar"',
        FORM: {
            CONFIRMATION: {
                LABEL: "",
                PLACEHOLDER: "inactivar",
            }
        }
    },
    INACTIVATE_CONTRACT: "Inactivar contrato",
    ACTIVATE_CONTRACT: "Activar contrato",
}

export const createPayableContractDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}